import { IonButton, IonIcon } from "@ionic/react";
import { checkmarkCircle, checkmarkOutline } from "ionicons/icons";
import { useState } from "react";
import productsController from "../../../../barrel/controllers/productsController";
import useHxfTranslation from "../../../../barrel/hooks/useHxfTranslation";
import HxfSelectorField from "../../HxfSelectorField/HxfSelectorField";
import HxfIonPopup from "../../ProductionUI/HxfIonPopup/HxfIonPopup";
import DefineProductParameterizedVariableValuesPopup from "../defineProductParameterizedVariableValues/DefineProductParameterizedVariableValuesPopup";
import styles from "./DefineProductPopup.module.scss";


export interface IDefineProductPopupShortcutProduct{
    Id_Product:any;
    name:any;
    code:any;
    arrayProductParameterizedVariables?:any[];
}
interface IProps{
    onClose?:any;
    onConfirm?:any;
    title?:any;
    customContent1?:any;
    hideProductSelectionInput?:any;
    disableProductSelectionInput?:any;
    arrayProductsSelectionShortcuts?:any;
    ignoreProductParameterizedVariables?:boolean;
}
function DefineProductPopup(props:IProps){

    const {t} = useHxfTranslation();
    const [resultingProductSelected, setResultingProductSelected] = useState<any>(null);
    const [productSelected, setProductSelected] = useState<any>(null);
    const [popupDefinedPVSData, setPopupDefinedPVSData] = useState<any>(null);
    const getSelectedProductValue = () => {
        if(productSelected?.Id){
            return {label:"("+productSelected?.code+")" + productSelected?.name, value: productSelected?.Id};
        }
        return null;
    }

    const checkIfConfirmEnabled = () => {

        return resultingProductSelected !== null;
    }
    return (
        <>
                {popupDefinedPVSData && (
                <DefineProductParameterizedVariableValuesPopup
                        
                        isLoading={false}
                        currentData={popupDefinedPVSData}
                        allowCurrentDataValuesLoad={true}
                        includeFullParameterizedVariablesData={true}
                        title={t('product.parameters')}
                        onClosePopup={() => {
                            setPopupDefinedPVSData(null);
                            setProductSelected(null);
                            setResultingProductSelected(null);
                            
                        }}
                        onSuccessConfirm={(res:any) => {
                            debugger;
                            setResultingProductSelected({...resultingProductSelected,  arrayProductParameterizedVariables:res});
                            setPopupDefinedPVSData(null);
                        }}
                />
        )}
        {!popupDefinedPVSData && (
            <>
                <HxfIonPopup onClose={() => {
                    props.onClose();
                }} title={props?.title ? props.title : t('select.a.product')} modelSettings={{contentHeightPct:85,customPopupMaxHeight:'650px'}} bottomConfirmationContainer={(
                    <div className={styles.container}>

                    <div>
                    <IonButton
                        disabled={!checkIfConfirmEnabled()}
                        className={styles.btnConfirm}
                        data-btn={"select-a-product-confirm-btn"}
                        size="large"
                        onClick={() => {
                            props.onConfirm(resultingProductSelected);
                        }}
                        >
                        <IonIcon slot="start" size="large" icon={checkmarkOutline} />
                        {t("confirm")}
                        </IonButton>
                        
                    </div>
                    </div>
                )} content={(
                    <div className={styles.container}>
                            {props?.customContent1 && (
                                <>{props.customContent1}</>
                            )}

                            {(props?.arrayProductsSelectionShortcuts && props?.arrayProductsSelectionShortcuts.length > 0) && (
                                <>
                                <div className={styles.shortcutsTitle}>{t('shortcuts')}</div>
                                <div className={styles.shortcutsContainer}>
                                    {props?.arrayProductsSelectionShortcuts.map((objProdShortcut:IDefineProductPopupShortcutProduct, index:any) => (
                                    <>
                                        <div key={"prodshortcut_" + index} className={styles.prodShortcutBtnContainer} onClick={() => {
                                           
                                            setProductSelected({Id:objProdShortcut.Id_Product, name:objProdShortcut.name, code:objProdShortcut.code, arrayProductParameterizedVariables:objProdShortcut?.arrayProductParameterizedVariables ? objProdShortcut?.arrayProductParameterizedVariables : []});
                                            setResultingProductSelected({
                                                Id_Product:objProdShortcut.Id_Product,
                                                name:objProdShortcut.name,
                                                code:objProdShortcut.code
                                            });
                                            if(objProdShortcut?.arrayProductParameterizedVariables && objProdShortcut?.arrayProductParameterizedVariables.length > 0){
                                                
                                                setPopupDefinedPVSData({
                                                    Id_Product:objProdShortcut.Id_Product,
                                                    name:objProdShortcut.name,
                                                    code:objProdShortcut.code,
                                                    arrayProductParameterizedVariables: objProdShortcut?.arrayProductParameterizedVariables,
                                      
                                                });
                                        
                                            }else{
                                            
                                                setPopupDefinedPVSData(null);
                                            }
                                        }}>
                                            <div>
                                                <div className={styles.shortCutCode}><b>{objProdShortcut.code}</b></div>
                                                <div className={styles.shortcutName}>{objProdShortcut.name}</div>
                                                
                                            
                                                {objProdShortcut?.arrayProductParameterizedVariables && (
                                                    <div className={styles.shortcutArrPPVVs}>
                                                        {objProdShortcut?.arrayProductParameterizedVariables.map((objPV:any, indexPV:any) => (
                                                            <div key={"arrppvvshortcut_" + index + "_" + indexPV}>
                                                                <b>{objPV.name}:</b> {objPV.Value}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                    ))}
                                </div></>
                            )}

                            {!props?.hideProductSelectionInput && (
                                        <HxfSelectorField

                                            style={{width:'100%'}}
                                            dataInputFieldAttributeValue="adjust-product-selector"
                                            searchingFilterKey={"searchBarFilter"}
                                                disabled={props?.disableProductSelectionInput}
                                                error={
                                                false
                                                }
                                                onChange={(evt, val) => {
        
                        
                    
                                                    if(!val?.fetchedData){
                                                        setProductSelected(null);
                                                        setPopupDefinedPVSData(null);
                                                        setResultingProductSelected(null);
                                                    }else{
                                                        setProductSelected(val?.fetchedData);
                                                        setResultingProductSelected({
                                                            Id_Product:val?.fetchedData?.Id,
                                                            name:val?.fetchedData?.name,
                                                            code:val?.fetchedData?.code
                                                        })
                                                    }
                                                    
                                                    if(val?.fetchedData?.arrayProductParameterizedVariables?.length > 0 && !props?.ignoreProductParameterizedVariables){
                                                        //ask to define ppvvs
                                                        setPopupDefinedPVSData({
                                                            //_indexSelected:index,
                                                            Id_Product:val.fetchedData.Id,
                                                            name:val.fetchedData.name,
                                                            code:val.fetchedData.code,
                                                            arrayProductParameterizedVariables: val.fetchedData.arrayProductParameterizedVariables,
                                                            //_isAddingNew:true
                                                        });
                                                
                                                    }else{
                                                        setPopupDefinedPVSData(null);
                                                    }
                                                }}
                                                value={getSelectedProductValue()}
                                                listJsonFunction={
                                                productsController().getProductsListJson
                                                }
                                                listJsonOptions={{includeParameterizedVariables:true}}
                                                uniqueId={"defproduct_product_sel"}
                                                labelPlaceholder={t("product")}
                                        />
    
                            )}
                    
                                    

                                    {resultingProductSelected?.arrayProductParameterizedVariables && (
                                        <div className={styles.arrPPVVs}>
                                            {resultingProductSelected?.arrayProductParameterizedVariables.map((objPV:any, index:any) => (
                                                <div key={"arrppvv_" + index}>
                                                    <b>{objPV.name}:</b> {objPV.Value}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                
                    </div>
                )}/>
            </>
        )}

        </>
    )
}

export default DefineProductPopup;